// FAQ Accordion Functionality
function toggleFAQ(element) {
  const faqItem = element.parentElement;
  const faqAnswer = faqItem.querySelector('.faq-answer');
  const faqQuestion = element;
  
  // Toggle active class
  faqAnswer.classList.toggle('active');
  faqQuestion.classList.toggle('active');
  
  // Close other open FAQs
  const allFaqItems = document.querySelectorAll('.faq-item');
  allFaqItems.forEach(item => {
    if (item !== faqItem) {
      const answer = item.querySelector('.faq-answer');
      const question = item.querySelector('.faq-question');
      answer.classList.remove('active');
      question.classList.remove('active');
    }
  });
}

// Fixed FAQ Accordion Functionality
function toggleFixedFAQ(element) {
  const fixedFaqAnswer = element.parentElement.querySelector('.fixed-faq-answer');
  const fixedFaqQuestion = element;
  
  // Toggle active class
  fixedFaqAnswer.classList.toggle('active');
  fixedFaqQuestion.classList.toggle('active');
}

// Initialize FAQ functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // FAQ functionality is ready
  console.log('FAQ Accordion initialized');
});
